
<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <a-button style="margin-right: 10px" type="primary" icon="plus" @click="handleAdd">新增</a-button>
        </div>
        <!--表格-->
        <div class="table">
          <zm-table
            :columns="table.columns"
            :rowKey="(record) => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :scroll="{ x: 1100 }"
          >
            <template v-slot:actions="{ text, record }">
              <a href="javascript:;" @click="() => handleView(record)">查看</a>
              <template v-if="record.status === 0">
                <a-divider type="vertical" />
                <a-popconfirm v-if="table.data.length" :title="`${record.userName}是否确认已到达现场参加面试？`" @confirm="() => handleConfirm(record)">
                  <a href="javascript:;">确认</a>
                </a-popconfirm>
              </template>
              <template v-if="record.status === 0">
                <a-divider type="vertical" />
                <a href="javascript:;" @click="() => handleCancel(record)">取消</a>
              </template>
              <template v-if="record.status === 1">
                <a-divider type="vertical" />
                <a href="javascript:;" @click="() => handleResult(record)">填写结果</a>
              </template>
              <template v-if="record.status === 2">
                <a-divider type="vertical" />
                <a href="javascript:;" @click="() => handleInduction(record)">入职</a>
              </template>

              <a-divider type="vertical" />
              <a-dropdown overlayClassName="actions_more">
                <a class="action_item" @click.stop="e => e.preventDefault()">
                  <a href="javascript:;">更多</a>
                  <a-icon type="down" style="color:#333333;margin-left:4px" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-if="record.status === 0 || record.status === 1">
                    <div class="action_item" @click.stop="handleEdit(record)">
                      <a href="javascript:;">编辑</a>
                    </div>
                  </a-menu-item>
                  <a-menu-item>
                    <div class="action_item" @click.stop="onDelete(record)">
                      <a href="javascript:;">删除</a>
                    </div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </zm-table>
        </div>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <cancel-modal ref="cancelModal" @refreshTable="initTableData"></cancel-modal>
    <result-modal ref="resultModal" @refreshTable="initTableData"></result-modal>
    <induct-modal ref="inductModal" @refreshTable="initTableData"></induct-modal>
    <!-- <import-modal ref="importModal" @refreshTable="initTableData"></import-modal> -->
    <view-modal ref="viewModal"></view-modal>
  </div>
</template>

<script>
import { getApplicantList, deleteApplicant, confirmApplication } from '@/api/applicant'
import editModal from './modules/editModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
// import importModal from './modules/importModal'
import viewModal from './modules/viewModal'
import { mapActions } from 'vuex'
import { getDictInfoByCode } from '@/api/dict'
import moment from 'moment'
import CancelModal from './modules/cancelModal.vue'
import ResultModal from './modules/resultModal.vue'
import InductModal from './modules/inductModal.vue'
export default {
  name: 'applicantList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initDictData()
    this.initTableData()
  },
  computed: {},
  components: {
    editModal,
    searchForm,
    baseCard,
    // importModal,
    viewModal,
    CancelModal,
    ResultModal,
    InductModal,
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [],
        config: {},
        columns: [
          {
            title: '姓名',
            dataIndex: 'userName',
            // width: 80
          },
          {
            title: '学历',
            dataIndex: 'educationStr',
            width: 60
          },
          {
            title: '性别',
            dataIndex: 'gender',
            customRender: (text) => {
              if (text === 1) return '男'
              if (text === 2) return '女'
            },
            width: 60
          },
          {
            title: '应聘岗位',
            dataIndex: 'departmentJobStr',
            width: 120
          },
          {
            title: '实习岗',
            dataIndex: 'internship',
            customRender: (text) => {
              if (text === 1) return '是'
              if (text === 0) return '否'
            },
            width: 70
          },
          {
            title: '邀约平台',
            dataIndex: 'invitePlatformStr',
            width: 100
          },
          {
            title: '预约面试时间',
            dataIndex: 'planInterviewTime',
            customRender: (text) => {
              return text ? moment(text).format('YYYY-MM-DD HH:mm') : ''
            },
            width: 120
          },
          {
            title: '在职状态',
            dataIndex: 'workStatus',
            customRender: (text) => {
              if (text === 1) return '待业'
              if (text === 2) return '在职'
            },
            width: 90
          },
          {
            title: '面试负责人',
            dataIndex: 'interviewerName',
            width: 100
          },
          {
            title: '当前状态',
            dataIndex: 'status',
            customRender: (text) => {
              if (text === 0) return '待面试'
              if (text === 1) return '确认面试'
              if (text === 2) return '面试通过'
              if (text === 3) return '面试未通过'
              if (text === 4) return '取消入职'
              if (text === 6) return '已入职'
              if (text === 7) return '取消面试'
            },
            width: 100
          },
          {
            title: '操作',
            align: 'right',
            fixed: 'right',
            width: 200,
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      },
    }
  },
  methods: {
    ...mapActions(['handleJobList']),
    initDictData () {
      getDictInfoByCode({ pCode: 'JOB_APPLICATION' }).then(res => {
        if (res.status === 0) {
          this.handleJobList(res.data)
        }
      })
    },
    // // 导入
    // handleImport () {
    //   this.$refs.importModal.setModel(this.model)
    //   this.$refs.importModal.open(true)
    // },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    async initTableData () {
      // if (this.searchModel.planInterviewTime) this.searchModel.planInterviewTime = moment(this.searchModel.planInterviewTime).format('YYYY-MM-DD')
      const res = await getApplicantList(this.searchModel).catch((err) => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.table.loading = false
        this.table.data = res.data.list
        this.pagination.total = res.data.total
      } else {
        this.$message.warning('获取数据失败！')
      }
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchModel,
        ...this.pagination
      }
      this.initTableData()
    },
    async deleteFn (ids) {
      const res = await deleteApplicant(ids).catch((err) => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
        this.initTableData()
      } else {
        this.$message.warning(res.info.message)
      }
    },
    // 删除操作
    onDelete (model) {
      const _this = this
      this.$confirm({
        title: `是否确认删除应聘人员${model.userName}`,
        onOk: () => {
          _this.deleteFn(model.id)
        }
      })
    },
    // 查看详情
    handleView (model) {
      this.$refs.viewModal.setTitle('查看应聘人员')
      this.$refs.viewModal.setModel(model) // 先设置类型，再打开
      this.$refs.viewModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑应聘人员')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 确认
    async handleConfirm (model) {
      const res = await confirmApplication({ intervieweeId: model.id }).catch(() => {
        this.$message.error('操作失败，请重试！')
      })
      if (res && res.status === 0) {
        this.$message.success('确认成功！')
        this.initTableData()
      } else {
        this.$message.warning(res.info.message)
      }
    },
    // 取消
    handleCancel (model) {
      this.$refs.cancelModal.setTitle('取消预约面试')
      this.$refs.cancelModal.setModel(model)
      this.$refs.cancelModal.open(true)
    },
    // 填写结果
    handleResult (model) {
      this.$refs.resultModal.setTitle('面试结果填写')
      this.$refs.resultModal.setModel(model)
      this.$refs.resultModal.open(true)
    },
    // 入职
    handleInduction (model) {
      this.$refs.inductModal.setTitle('入职')
      this.$refs.inductModal.setModel(model)
      this.$refs.inductModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增应聘人员')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // // 批量删除
    // async batchDel () {
    //   const searchModel = this.selectedRows
    //   if (!searchModel || searchModel.length === 0) {
    //     this.$message.warning('请至少选择一行数据进行删除！')
    //     return
    //   }
    //   let params = ''
    //   searchModel.map((item) => {
    //     params += item.id + ','
    //   })
    //   params = params.substring(0, params.length - 1)
    //   this.deleteFn(params)
    // },
  }
}
</script>

<style scoped  lang="less">
.listContent {
  .table {
    margin-top: 10px;
  }
}
</style>